import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import AddressDisplay from 'components/FrictionlessCheckout/DeliverTo/AddressDisplay/AddressDisplay';
import AddressDisplayEN from 'components/FrictionlessCheckout/DeliverTo/AddressDisplay/locales/AddressDisplay_en_US';
import AddressDisplayFR from 'components/FrictionlessCheckout/DeliverTo/AddressDisplay/locales/AddressDisplay_fr_CA';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(AddressDisplayEN, AddressDisplayFR);

const localizationSelector = createStructuredSelector({
    edit: getTextFromResource(getText, 'edit'),
    changeShippingAddress: getTextFromResource(getText, 'changeShippingAddress')
});

const fields = createSelector(localizationSelector, localization => {
    return {
        localization
    };
});

const withComponentProps = wrapHOC(connect(fields, null));

export default withComponentProps(AddressDisplay);
